module.exports = __webpack_public_path__ + "img/up-right-and-down-left-from-center.d864ca12.svg";